import React from "react";
import reactStringReplace from "react-string-replace";
import twemoji from "@twemoji/api";
import { CommonIcon, getMsgReplyLabel } from "./utils";

// Unicode emoji 正则（匹配表情符号、修饰符、ZWJ 序列等）
const UNICODE_EMOJI_REG = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})(?:\uFE0F)?(?:\u200D(?:\p{Emoji_Presentation}|\p{Extended_Pictographic})(?:\uFE0F)?)*|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}/gu;

function UnicodeEmoji({ emoji, id }) {
  // twemoji.convert.toCodePoint 处理 ZWJ / 肤色修饰等复合 emoji
  const cp = twemoji.convert.toCodePoint(emoji).toLowerCase();
  const src = `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/${cp}.png`;
  return (
    <img
      key={id}
      src={src}
      alt={emoji}
      className="imc-emoji-icon"
      style={{ width: '1.1em', height: '1.1em', verticalAlign: '-0.15em', display: 'inline-block' }}
      onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.insertAdjacentText('afterend', emoji); }}
    />
  );
}

export default function TextMessage({ msg, replyMsgsMap, getEmojiConfig }) {
  const { body, idClient, ext, custom } = msg;
  let replyText = "";
  const mentionTexts = [];

  const rawSource = ext || custom;
  if (rawSource) {
    try {
      const parsed = typeof rawSource === "string" ? JSON.parse(rawSource) : rawSource;
      // 格式一：{ yxAitMsg: { accountId: { text, segments } } }
      if (parsed.yxAitMsg && typeof parsed.yxAitMsg === "object") {
        Object.values(parsed.yxAitMsg).forEach((v) => {
          if (v && v.text) mentionTexts.push(v.text);
        });
      }
      // 格式二（旧版）：顶层 key 是 accountId，值是 { text, segments }
      if (!mentionTexts.length) {
        Object.values(parsed).forEach((v) => {
          if (v && typeof v === "object" && v.text) mentionTexts.push(v.text);
        });
      }
      // 回复预览：直接从父层预构建的 replyMsgsMap 中取，避免 render 内查 store
      if (parsed.yxReplyMsg && replyMsgsMap) {
        const replyMsg = replyMsgsMap[idClient];
        if (replyMsg && replyMsg !== 'noFind' && typeof replyMsg === 'object') {
          replyText = "| " + (replyMsg.fromNick || replyMsg.from || '') + ": " + getMsgReplyLabel(replyMsg);
        }
      }
    } catch (e) {}
  }

  const { EMOJI_ICON_MAP_CONFIG, INPUT_EMOJI_SYMBOL_REG } = getEmojiConfig();

  let text = reactStringReplace(
    body || "",
    /(https?:\/\/\S+)/gi,
    (match, i) => (
      <a key={idClient + match + i} href={match} target="_blank" rel="noopener noreferrer">
        {match}
      </a>
    )
  );
  text = reactStringReplace(text, INPUT_EMOJI_SYMBOL_REG, (match, i) => (
    <CommonIcon
      key={idClient + match + i}
      className="imc-emoji-icon"
      type={EMOJI_ICON_MAP_CONFIG[match]}
    />
  ));
  // Unicode emoji（系统键盘输入）统一替换为 Twemoji 图片，避免 iOS/Android 显示不一致
  text = reactStringReplace(text, UNICODE_EMOJI_REG, (match, i) => (
    <UnicodeEmoji key={`${idClient}-ue-${i}`} emoji={match} />
  ));
  mentionTexts.forEach((mentionText, mi) => {
    if (!mentionText) return;
    const escaped = mentionText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    text = reactStringReplace(text, new RegExp(`(${escaped})`, "g"), (match, i) => (
      <span key={`${idClient}-at${mi}-${i}`} className="imc-mention">{match}</span>
    ));
  });

  return (
    <div
      className={`imc-bubble imc-bubble-${msg.flow}`}
      style={{ backgroundColor: msg.flow === "in" ? "#fff" : "#FDF9ED" }}
    >
      {replyText.length > 0 && (
        <div className="imc-reply-bar">{replyText}</div>
      )}
      {text}
    </div>
  );
}
